<template>
  <div class="save-checklist-dialog-template-type">
    <v-radio-group v-model="templateType"
                   class="template-type-container"
    >
      <div v-for="option in templateTypeOptionsValues"
           :key="`option-${option}`"
           :class="`templateType__card-${option}`"
           class="d-flex flex-column"
      >
        <div :value="option"
             class="template-type-card clickable mb-2"
             :class="{'template-type-card--active': option === templateType}"
             @click="templateType = option"
        >
          <div class="d-flex align-center">
            <img :src="getTemplateImage(option)"
                 height="40"
                 width="40"
                 class="mr-2"
                 alt="template"
            />
            <div v-if="option === TEMPLATE_TYPE_OPTIONS.NEW">
              <p class="text--small text--bold">
                {{ $t('project.checklist.dialogs.SaveChecklistDialog.createNewModel') }}
              </p>
              <p class="text--small text--regular">
                {{ $t('project.checklist.dialogs.SaveChecklistDialog.createNewModelSubtitle') }}
              </p>
            </div>
            <div v-else>
              <p class="text--small text--bold">
                {{ $t('project.checklist.dialogs.SaveChecklistDialog.updateExistingModel') }}
              </p>
              <p class="text--small text--regular">
                {{ $t('project.checklist.dialogs.SaveChecklistDialog.updateExistingModelSubtitle') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
  import { TEMPLATE_TYPE_OPTIONS } from '@/common/utils/templateTypes.ts'

  export default {
    name: 'SaveChecklistTemplateType',
    props: {
      defaultTemplateType: {
        required: true,
        validator: (value) => {
          return value === null || typeof value === 'string'
        },
      },
    },
    data () {
      return {
        TEMPLATE_TYPE_OPTIONS,
        templateType: this.defaultTemplateType,
      }
    },
    computed: {
      templateTypeOptionsValues () {
        return Object.values(TEMPLATE_TYPE_OPTIONS)
      },
    },
    watch: {
      templateType (value) {
        this.$emit('change-template-type', value)
      },
    },
    methods: {
      getTemplateImage (templateType) {
        return new URL(`../../../assets/img/checklist/checklist-template-${templateType}.svg`, import.meta.url).href
      },
    },
  }
</script>

<style lang="scss">
@import "vuetify/settings";
  .save-checklist-dialog-template-type {
    .template-type-card {
      padding: $spacer * 4 $spacer * 6;
    }

    .template-type-container {
      .v-input--radio-group__input {
        gap: 16px;
      }

      .template-type-card {
        border: 1px solid #DEE2E6;
        border-radius: 4px;

        &--active {
          outline: 2px solid rgb(var(--v-theme-primary));
          outline-offset: -2px;
          background-color: rgb(var(--v-theme-primary-lighten-4));
        }

        .caption {
          color: #717B85;
          font-size: 12px;
        }
      }
    }
  }
</style>
